import UserSvc from '@/common/service/modules/UserSvc';
import ClassSvc from '@/common/service/modules/ClassSvc';
import { modalAlertNames } from '@/components/common/globalComponent';
import { clone, cloneDeep } from 'lodash';

export default {
  /**
   * 유저 로그인
   * @param commit
   * @param {object} payload
   * @return {Promise<Object>}
   */
  async login({ commit }, payload) {
    const cloneParam = cloneDeep(payload);

    const deviceValue = localStorage.getItem('deviceInfo');
    if (deviceValue) cloneParam.device = JSON.parse(deviceValue);
    const { data, accessToken } = await UserSvc.login(cloneParam);
    const { entity } = data;

    if (data.code === 1) {
      commit('storeLogin', { userData: entity, accessToken: accessToken });
    } else {
      commit('setErrorMessage', data.message);
    }
    return !!accessToken;
  },

  /**
   * 로그아웃
   * @param commit
   * @return {Promise<void>}
   */
  async logout({ commit }, params) {
    const res = await UserSvc.logout(params);
    if (res.code === 1) {
      commit('resetUserData');
      location.replace('/');
    }
  },

  async fetchUserDetail({ dispatch, commit, getters }) {
    const userNo = getters.getUserNo;
    // const userNo = 100;
    const { code, entity } = await UserSvc.getUserDetail(userNo);
    if (code === 1) {
      commit('setUserData', entity);
    } else {
      commit('setErrorMessage', '회원 정보를 찾을 수 없습니다.');
    }
  },
  async updatePhoneNumber({ commit }, payload) {
    const { code, entity, message } = await UserSvc.updatePhoneNumber(payload);
    if (code === 1) {
      commit('setUserData', entity);
    } else {
      commit('setErrorMessage', message);
    }
  },

  async reqAuthCode({ commit }, payload) {
    const { code, entity, message } = await UserSvc.reqAuthCode(payload);
    if (code === 1) {
      commit('setAuthCode', entity);
      return { code: code, message: message, entity: entity };
    } else {
      commit('setErrorMessage', '인증코드 요청에 실패했습니다.');
      return { code: code, message: '인증코드 요청에 실패했습니다.', entity: entity };
    }
  },

  async confirmAuthCode({ commit }, payload) {
    const response = await UserSvc.confirmAuthCode(payload);
    return response.entity === 1;
  },

  async updatePassword({ commit }, payload) {
    const response = await UserSvc.updatePassword(payload);
    if (!response) return false;
    return response;
  },

  async fetchMainInfo({ commit }, userNo) {
    const response = await UserSvc.getMainPageInfo(userNo);
    const { data } = response;
    await commit('setMainPageInfo', data.entity);
  },

  async fetchStudyList({ commit, getters }, userNo) {
    const { data } = await ClassSvc.getStudyList({ userNo: userNo });
    commit('setStudyList', data.entity.list);
  },

  async updateIsPush({ commit }, payload) {
    const response = await UserSvc.updateIsPush(payload);

    // await commit('user/setIsPush', payload);
  }
};
